import { Id } from "@planzone/dto";
import { State, Selector } from "./types";

function get(getState: () => State, planzoneId: Id) {
  return getState().find((res) => res.id === planzoneId);
}

function queryState(getState: () => State, planzoneId: Id) {
  return <Result>(
    query: (res: State[number]) => Result,
    fallBack: Result,
  ): Result => {
    const state = get(getState, planzoneId);

    return state ? query(state) : fallBack;
  };
}

function createSelector(getState: () => State): Selector {
  return {
    isPlanzoneLogsRetrievalRequestFailure(id) {
      return queryState(getState, id)((res) => res.request.isFailure, false);
    },
    isPlanzoneLogsRetrievalRequestPending(id) {
      return queryState(getState, id)((res) => res.request.isPending, false);
    },
    isPlanzoneLogsRetrievalRequestSuccess(id) {
      return queryState(getState, id)((res) => res.request.isSuccessful, false);
    },
    getPlanzoneLogs(id) {
      return queryState(getState, id)(
        (res) => ({ logs: res.logs, pages: res.pages }),
        { logs: [], pages: 0 },
      );
    },
  };
}

export { createSelector };
